import {
  QuickResponderIcon,
  FastShipperIcon,
  AccurateDescriberIcon,
} from '@c/icons';

import { Tooltip } from 'react-tooltip';

export function SellerAccolades({
  quick_replies = 0,
  fast_shipper = 0,
  as_described = 0,
  iconOnly = false,
}: {
  quick_replies: number;
  fast_shipper: number;
  as_described: number;
  iconOnly?: boolean;
}) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-6 px-4 sm:flex-row sm:justify-normal sm:gap-x-16">
      {quick_replies > 9 && (
        <Accolade iconOnly={iconOnly} type="quick_replies" />
      )}
      {fast_shipper > 9 && <Accolade iconOnly={iconOnly} type="fast_shipper" />}
      {as_described > 9 && <Accolade iconOnly={iconOnly} type="as_described" />}
      {iconOnly && <Tooltip id="accolade-tooltip" />}
    </div>
  );
}

export function Accolade({
  type,
  iconOnly = false,
}: {
  type: 'quick_replies' | 'fast_shipper' | 'as_described';
  iconOnly?: boolean;
}) {
  return (
    <div
      className="flex items-center gap-x-0 rounded-full bg-[#F1F1F1] px-8 py-2 sm:gap-[1rem] sm:rounded-none sm:bg-transparent sm:px-0"
      data-tooltip-id={'accolade-tooltip'}
      data-tooltip-content={SellerAccoladesData[type].title}
    >
      {SellerAccoladesData[type].icon}
      <div className={`flex flex-col gap-[0.4rem] ${iconOnly ? 'hidden' : ''}`}>
        <span className="text-[1.8rem] font-semibold">
          {SellerAccoladesData[type].title}
        </span>
      </div>
    </div>
  );
}

export const SellerAccoladesData = {
  quick_replies: {
    title: 'Quick Responder',
    description: 'Usually responds within 3 hours.',
    icon: <QuickResponderIcon />,
  },
  fast_shipper: {
    title: 'Fast Shipper',
    description: 'Usually ships in 1-3 business days.',
    icon: <FastShipperIcon />,
  },
  as_described: {
    title: 'Accurate Describer',
    description: 'Items accurately match their descriptions.',
    icon: <AccurateDescriberIcon />,
  },
};
